var React = require('react');

function DownloadArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(21.524 14.5) rotate(-90)"},[React.createElement("path",{"fill":"currentColor","d":"M3.69,0a.444.444,0,0,1,.249.112L7.1,2.906a.472.472,0,0,1,.194.454.462.462,0,0,1-.312.377.442.442,0,0,1-.464-.127L3.648,1.073.781,3.609a.442.442,0,0,1-.464.127A.462.462,0,0,1,0,3.36.472.472,0,0,1,.2,2.906L3.357.113A.442.442,0,0,1,3.69,0Z","transform":"translate(2.957 -13.589) rotate(-90)","key":0}),React.createElement("path",{"className":"icon-svg--stroke","d":"M7.558,0H0","transform":"translate(0.422 -13.466) rotate(-90)","key":1}),React.createElement("rect",{"fill":"currentColor","width":"11","height":"1","transform":"translate(3.5 -17.729)","key":2})]));
}

DownloadArrow.defaultProps = {"viewBox":"0 0 8.558 14.578"};

module.exports = DownloadArrow;

DownloadArrow.default = DownloadArrow;
